import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerUrlService } from './server-url.service';

@Injectable({
    providedIn: 'root'
})

export class AutoLoginService {

    constructor(
        private http: HttpClient,
        private serverUrlService: ServerUrlService
    ) {

    }

    verifyToken(token) {
        return this.http.post(`${this.serverUrlService.getUrl()}/usuarios/valida-token`, {
            token: token,
            cliente: this.serverUrlService.getName()
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
        });
    }

}
